async function generateHmacSha256(message, secretKey) {
  const enc = new TextEncoder();
  const key = await crypto.subtle.importKey(
    "raw",
    enc.encode(secretKey),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );
  const signature = await crypto.subtle.sign("HMAC", key, enc.encode(message));
  return Array.from(new Uint8Array(signature))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

async function getFreshAuth() {
  const shopPermanentDomain = "levis-india-store.myshopify.com";
  const timestamp = Date.now().toString();
  const marmeto_string_1 = timestamp.substring(0, 4);
  const marmeto_string_2 = timestamp.substring(4);

  const baseString = marmeto_string_1 + shopPermanentDomain + marmeto_string_2;
  const marmeto_hash = await generateHmacSha256(baseString, "yTGfof2MPlM1bLlvKSM");

  return {
    key: marmeto_hash,
    timestamp: timestamp,
  };
}

//Utility to safely parse and round point values
function parsePoints(pointString) {
  const parsed = parseFloat(pointString);
  return isNaN(parsed) ? 0 : Math.round(parsed);
}

//Fetch Available Points
async function fetchAvailablePoints() {
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  let meta = sessionStorage.getItem("availableRedTabPointsMeta");
  let storedCustomerPhone = null;
  let storedAvailablePoints = null;
  let sessionTime = 0;
  const customerLoggedIn = JSON.parse(getCookie("customer_logged_in"));
  const availablePointsCacheExpiryTime = document.body.dataset.availablePointsCacheTime ? JSON.parse(document.body.dataset.availablePointsCacheTime) : 0;
  const LOYALTY_CONTAINER = document.querySelector(".loyalty-page");
  const availablePointsElem = LOYALTY_CONTAINER.querySelector(".avaialable-points");

  if (meta){
    const { createdAt, customerPhone } = JSON.parse(meta);
    storedCustomerPhone = customerPhone;
    if (storedCustomerPhone.length > 10 && storedCustomerPhone.startsWith("+91")) {
      storedCustomerPhone = storedCustomerPhone.slice(3);
    }
    const now = Date.now();
    sessionTime = (now - createdAt) / (1000 * 60);
  }

  if (customerLoggedIn){
    let customerPhone = LOYALTY_CONTAINER.getAttribute("data-customerPhone");
    if (customerPhone.length > 10 && customerPhone.startsWith("+91")) {
      customerPhone = customerPhone.slice(3);
    }
    if (customerPhone == storedCustomerPhone){
      storedAvailablePoints = window.sessionStorage.getItem('availableRedTabPoints') && JSON.parse(window.sessionStorage.getItem('availableRedTabPoints'));
    }else{
      storedAvailablePoints = null;
    }
  }

  if (sessionTime > availablePointsCacheExpiryTime || storedAvailablePoints == null){
    console.log("fetch_available_points");
    try {
      const { timestamp, key } = await getFreshAuth();
      let customerPhone = LOYALTY_CONTAINER.getAttribute("data-customerPhone");
      if (customerPhone.length > 10 && customerPhone.startsWith("+91")) {
        customerPhone = customerPhone.slice(3);
      }

      const body = {
        easy_id: customerPhone,
        activity_code: "LevisRedeem",
        store_code: "EcommerceLevis",
        country_code: "91",
      };

      const res = await fetch("https://leviseasyrewards.marmeto.com/api/get/customer/available-points", {
        method: "POST",
        headers: {
          hash: key,
          timestamp: timestamp,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const data = await res.json();
      if (data.success && data.data.ReturnCode === 0) {
        const points = parsePoints(data.data.AvailablePoints);
        availablePointsElem.innerText = points;
      }
    } catch (err) {
      console.error("Error fetching available points:", err);
    }
  }else{
    console.log("local_available_points");
    availablePointsElem.innerText = storedAvailablePoints;
  }
}

//Fetch Transaction Details
async function fetchTransactionDetails() {
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  let data = null;
  let sessionTime = 0;
  let storedCustomerPhone = null;
  const customerLoggedIn = JSON.parse(getCookie("customer_logged_in"));
  let transactionDetailsData = sessionStorage.getItem('easy-rewards-transaction-details') && JSON.parse(sessionStorage.getItem('easy-rewards-transaction-details'));
  const meta = sessionStorage.getItem('easyRewardsTransactionDetailsMeta');
  const transactionDetailsAPICacheExpiryTime = document.body.dataset.transactionDetailsCacheTime ? JSON.parse(document.body.dataset.transactionDetailsCacheTime) : 0;
  

  const LOYALTY_CONTAINER = document.querySelector(".loyalty-page");
  const noTransactionImg = LOYALTY_CONTAINER.querySelector(".no-transaction-found");
  const transactionsFound = LOYALTY_CONTAINER.querySelector(".transactions-found");

  if (meta){
    const { createdAt, customerPhone } = JSON.parse(meta);
    storedCustomerPhone = customerPhone;
    if (storedCustomerPhone && storedCustomerPhone.length > 10 && storedCustomerPhone.startsWith("+91")) {
      storedCustomerPhone = storedCustomerPhone.slice(3);
    }
    const now = Date.now();
    sessionTime = (now - createdAt) / (1000 * 60);
  }

  if (customerLoggedIn){
    let customerPhone = LOYALTY_CONTAINER.getAttribute("data-customerPhone");
    if (customerPhone.length > 10 && customerPhone.startsWith("+91")) {
      customerPhone = customerPhone.slice(3);
    }
    if (storedCustomerPhone != customerPhone){
      transactionDetailsData = null;
      window.sessionStorage.removeItem("easy-rewards-transaction-details");
      window.sessionStorage.removeItem("easyRewardsTransactionDetailsMeta");
    }
  }

  if (transactionDetailsData == null || sessionTime > transactionDetailsAPICacheExpiryTime){
    try {
      const { timestamp, key } = await getFreshAuth();
      let customerPhone = LOYALTY_CONTAINER.getAttribute("data-customerPhone");
      if (customerPhone.length > 10 && customerPhone.startsWith("+91")) {
        customerPhone = customerPhone.slice(3);
        
        const body = {
          easy_id: customerPhone,
          store_code: "EcommerceLevis",
          country_code: "91",
        };

        const res = await fetch("https://leviseasyrewards.marmeto.com/api/get/customer/transaction-details", {
          method: "POST",
          headers: {
            hash: key,
            timestamp: timestamp,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });
        data = await res.json();
        console.log("fetch_transaction_details");
      }else{
        handleKpAndShopifyLogin(window.location.href)
      }
    }catch (err) {
      console.error("Error fetching transaction details:", err);
    }
    } else{
      data = transactionDetailsData;
      console.log("local_transaction_details");
    }

    const transactions = data?.data?.MemberTransactionResponseListDTO;
    if (!transactions || transactions.length === 0) return;


    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    const renderTransaction = (txn) => {
      if (txn.BillNo == null) return;
      const date = new Date(txn.BillDate);
      const formattedDate = `${date.getDate().toString().padStart(2, "0")} ${months[date.getMonth()]} ${date.getFullYear()}`;

      let entryType = "";
      let reasonForEntry = "";

      switch (txn.EasyPointTypeId) {
        case "1":
        case "27":
          entryType = "Credited";
          reasonForEntry = "Loyalty Points Earned";
          break;
        case "2":
          entryType = "Debited";
          reasonForEntry = "Loyalty Points Redeemed";
          break;
        case "5":
          entryType = "Credited";
          reasonForEntry = "Bonus Points";
          break;
        case "14":
          entryType = "Debited";
          reasonForEntry = "Points Expired";
          break;
        case "15":
          entryType = "Debited";
          reasonForEntry = "Points Under Reconciliation";
          break;
        case "16":
          entryType = "Credited";
          reasonForEntry = "Referral Points";
          break;
        case "30":
          entryType = "Debited";
          reasonForEntry = "Return Items/Orders";
          break;
      }

      const isCredit = entryType !== "Debited";
      const rawPoints = isCredit ? txn.TotalAccruedPoints : txn.TotalRedeemPoints;
      console.log(txn);
      const points = parsePoints(rawPoints);
      const sign = isCredit ? "+" : "-";

      const div = document.createElement("div");
      div.className = `er-transactions tw-border tw-rounded tw-flex tw-p-4 tw-gap-4 tw-justify-between tw-items-center ${entryType}`;

      const detailsHtml = (txn.EasyPointTypeId === 5 || txn.EasyPointTypeId === 14)
        ? `<p class="tw-font-secondary tw-text-[12px] md:tw-text-[14px] tw-leading-normal tw-text-black">${reasonForEntry}</p>`
        : `<p class="tw-font-secondary tw-text-[12px] md:tw-text-[14px] tw-leading-normal tw-text-black">${reasonForEntry} on <span>Bill No: ${txn.BillNo}</span></p>`;

      div.innerHTML = `
        <div class="tw-flex tw-flex-col tw-gap-2">
          ${detailsHtml}
          <p class="tw-font-primary tw-text-[10px] md:tw-text-[12px] tw-leading-normal">On ${formattedDate}</p>
        </div>
        <p class="tw-font-secondary tw-text-[12px] md:tw-text-[14px] tw-leading-normal ${entryType}">${sign}${points}</p>
      `;

      transactionsFound.appendChild(div);
    };

    if (Array.isArray(transactions)) {
      transactions.forEach(renderTransaction);
    } else {
      renderTransaction(transactions);
    }
    if (!transactionsFound.childElementCount){
      if (noTransactionImg.classList.contains("tw-hidden")){
        noTransactionImg.classList.remove("tw-hidden");
      }
    }else{
      noTransactionImg.classList.add("tw-hidden");
    }
  }
(async function () {
  showLoader();
  await fetchAvailablePoints();
  await fetchTransactionDetails();
  closeLoader();
})();
